import { type CampaignInfo, type CouponInfo, type CouponSelect } from '@/typings/reward-task'
import type { UpgradeQuoteInfo } from '@/typings/subscribe'
import ApiClient from '@/utils/api-client'
import { getBaseURL } from '@/utils/common'

export function getCampaignTasks(): Promise<CampaignInfo> {
  return ApiClient.get(`${getBaseURL()}/campaign/guide/tasks`)
}

export function claimCampaignReward(): Promise<CampaignInfo> {
  return ApiClient.post(`${getBaseURL()}/campaign/guide/claim-reward`)
}

export function validateCampaign(): Promise<void> {
  return ApiClient.post(`${getBaseURL()}/campaign/guide/validate`)
}

export function assignGuideTask(): Promise<void> {
  return ApiClient.post(`${getBaseURL()}/campaign/guide/assign`)
}

export function getCoupon(): Promise<CouponInfo[]> {
  return ApiClient.get(`${getBaseURL()}/campaign/coupons/available`)
}

export function QuotaMemberPrice(member_id: number, user_coupon_id: number): Promise<CouponSelect> {
  return ApiClient.post(`${getBaseURL()}/member/member/quota_member_price`, { member_id, user_coupon_id })
}

export function getFbclid(device_id: string): Promise<{ fbclid: string }> {
  return ApiClient.get(`${getBaseURL()}/campaign/public/facebook/link?device_id=${device_id}`)
}

export function setFbclid(device_id: string, fbclid: string, expire_in = 3600 * 24 * 30): Promise<void> {
  return ApiClient.post(`${getBaseURL()}/campaign/public/facebook/link`, { device_id, fbclid, expire_in })
}

export function reward(key: string): Promise<CouponInfo> {
  return ApiClient.post(`${getBaseURL()}/campaign/marketing/reward`, { key }, false)
}

//国内续费 
// 检查是否可以续费
export function checkRenewal(): Promise<{eligible: boolean, reason: string}> {
  return ApiClient.get(`${getBaseURL()}/member/user-member/renewal/check`)
}

//询价
export function getQuote(): Promise<{member_id: number, apply_discount: boolean, price: number ,discount_price: number}> {
  return ApiClient.post(`${getBaseURL()}/member/user-member/renewal/quote`,{

  })
}

//发起续费
export function startRenewal(payment_channel:string,user_coupon_id?:number): Promise<{order_no: string, amount: number ,status: number,
  expected_expire_at: number,
  added_duration: number,
  next_action:{
  action: string,
  data: string,
}}> {
  return ApiClient.post(`${getBaseURL()}/member/user-member/renewal`,{
    user_coupon_id,
    payment_channel
  })
}

//查询订单
export function getOrder(order_no: string): Promise<{order:{
  order_no: string,
  amount: number,
  status: number,
  created_at: string,
  complete_time: string
}}> {
  return ApiClient.get(`${getBaseURL()}/member/user-member/renewal/orders/${order_no}`)
}